import { render, staticRenderFns } from "./WordButtons.vue?vue&type=template&id=19c64023&lang=html&"
import script from "./WordButtons.vue?vue&type=script&lang=js&"
export * from "./WordButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports